import { useQuery } from "@tanstack/react-query";

import API, { GetInferencesQuery } from "../api";

function useInferences({
  selectedDates,
  bbox,
  validated,
  asPoints,
  is_whale,
  min_coastline_distance,
  min_confidence,
  subResource = "",
}: GetInferencesQuery) {
  const { isPending, error, data, refetch } = useQuery({
    queryKey: [
      "inferences",
      bbox?.join(","),
      selectedDates.join(","),
      validated,
      is_whale,
      min_coastline_distance,
      min_confidence,
      subResource,
      asPoints,
    ],
    queryFn: () =>
      API.getInferences({
        selectedDates,
        bbox,
        validated,
        is_whale,
        min_coastline_distance,
        min_confidence,
        asPoints,
        subResource,
      }),
  });

  return {
    error,
    isLoading: isPending,
    inferences: data,
    refetch,
  };
}

export default useInferences;
